import React from 'react';

import { useFeatureFlag } from 'src/featureFlags/useFeatureFlag';

export const FeatureFlag = ({
  name,
  children = null,
  defaultChildren = null,
  notTargeted = false,
}: {
  name: string;
  children?: React.ReactNode;
  defaultChildren?: React.ReactNode;
  notTargeted?: boolean;
}) => {
  const isEnabled = useFeatureFlag(name);

  if (isEnabled && !notTargeted) {
    return <>{children}</>;
  }

  if (!isEnabled && notTargeted) {
    return <>{children}</>;
  }

  return <>{defaultChildren}</>;
};

export const FeatureFlagNotTargeted = (
  props: Omit<React.ComponentProps<typeof FeatureFlag>, 'notTargeted'>,
) => <FeatureFlag {...props} notTargeted />;
